import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '@mui/icons-material/Close';

const DeleteModal = (props) => {
  const { isModalOpen, handleClose, handleUpdate, title, content } = props;
  return (
    <Modal
      animation="true"
      style={{ zIndex: '8999' }}
      show={isModalOpen}
      onHide={handleClose}
      className="CompanyManagement"
      dialogClassName="CompanyMemberManagement DeleteModal"
    >
      <Modal.Header>
        <Modal.Title className="modal-title">{title}</Modal.Title>
      
        {/* 解決籃框問題，自訂MUI按鈕 */}
        <button
          onClick={handleClose}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            marginLeft: 'auto'
          }}
        >
          <CloseIcon fontSize="medium" />
        </button>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <p style={{fontSize: '13px', paddingTop: '15px'}}>{content}</p>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <Button className="btn btn-cancel" onClick={handleClose}>
          取消
        </Button>
        <Button className="btn btn-custom" onClick={handleUpdate}>
          確認
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
